export class Queue<T> {
	_data: Array<T>;

	constructor() {
		this._data = [];
	}

	enqueue(item: T) {
		this._data.push(item);
	}

	dequeue(): T | void {
		return this._data.shift();
	}

	peek(): T | void {
		return this._data[0];
	}

	popBack(): T | void {
		return this._data.pop();
	}

	items(): Array<T> {
		return this._data;
	}
}
